import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 18.26l-7.05 3.95 1.57-7.93L.6 8.79l8.02-.95L12 .5l3.39 7.34 8.02.95-5.93 5.49 1.57 7.93L12 18.26z"/>
  </SvgIcon>
);